// Import Swiper styles
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'

import { A11y, Keyboard, Mousewheel, Navigation } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

import { PhnxVideoHolder } from '@/components/01-atoms/VideoHolder/VideoHolder'
import { StylePanelProps } from '@/lib/stylePanel'

import { PhnxSectiontitle } from '../../01-atoms/Sectiontitle/Sectiontitle'
import styles from './Videoslider.module.css'

export type VideosliderProps = {
  title?: string
  description?: string
  items?: {
    title?: string
    description?: string
    video?: {
      url: string
      altText?: string
      type: 'youtube' | 'vimeo'
    }[]
  }[]
} & StylePanelProps

export const PhnxVideoslider: React.FC<VideosliderProps> = ({
  title,
  description,
  items,
  backgroundColor = '#1b1f22',
  textColor = '#FFF',
}) => {
  const style = {
    backgroundColor,
    color: textColor,
  }
  return (
    <div style={style} className="stylepanel">
      <div className={styles.videoslider}>
        <div className="container">
          <div className={styles.content}>
            <PhnxSectiontitle subtitle={title ? title : ''} variant={'quaternary'} />

            {/*
            {title && (
              <div className={styles.title}>
                <h2>{title}</h2>
              </div>
            )} */}
            {description && (
              <div className={styles.description}>
                <p>{description}</p>
              </div>
            )}
          </div>

          <div className={styles.slider}>
            <Swiper
              slidesPerView={3}
              spaceBetween={30}
              breakpoints={{
                200: {
                  slidesPerView: 1,
                  spaceBetween: 30,
                },
                320: {
                  slidesPerView: 1,
                  spaceBetween: 30,
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 30,
                },
                1024: {
                  slidesPerView: 3,
                  spaceBetween: 30,
                },
              }}
              keyboard={{
                enabled: true,
              }}
              navigation={{
                nextEl: `.${styles.next}`,
                prevEl: `.${styles.prev}`,
              }}
              mousewheel={true}
              loop={true}
              modules={[A11y, Keyboard, Mousewheel, Navigation]}
              className={styles.mySwiper}
            >
              {items &&
                items.length > 0 &&
                items.map((item, index) => (
                  <SwiperSlide key={index}>
                    <div className={styles.slide}>
                      <div className="video-container">
                        {item.video && item.video.length > 0 && (
                          <PhnxVideoHolder
                            video={[
                              {
                                url: item.video[0].url,
                                altText: item.video[0].altText,
                                type: item.video[0].type,
                              },
                            ]}
                          />
                        )}
                      </div>
                      <div className={styles.content}>
                        {item.title && (
                          <div className={styles.title}>
                            <h3>{item.title}</h3>
                          </div>
                        )}
                        {item.description && (
                          <div className={styles.description}>{item.description}</div>
                        )}
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
            </Swiper>

            <div className={`swiper-button-prev ${styles.prev}`}>
              <button className={styles.prev}>
                <span className={`fx-icon ${styles.icon}`}>
                  <span className={`fx-icon fx-icon-arrow-down-lg`}></span>
                  <span className="sr-only">Previous</span>
                </span>
              </button>
            </div>
            <div className={`swiper-button-next ${styles.next}`}>
              <button className={styles.next}>
                <span className={`fx-icon ${styles.icon}`}>
                  <span className={`fx-icon fx-icon-arrow-down-lg`}></span>
                  <span className="sr-only">Next</span>
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
